import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { Subscription } from 'rxjs';

import { AppService } from '../../../../app.service';
import { IncomingMessage } from '../../../notification/incoming-message';
import { IncomingMessageEvent } from '../../../notification/incoming-message-event';
import { IncomingMessageEventProvider } from '../../../notification/incoming-message-event-provider';

@Injectable({
  providedIn: 'root',
})
export class NotificationApi {
  private _notificationRequestSub: Subscription;

  constructor(
    private appService: AppService,
    private afMessaging: AngularFireMessaging,
    private incomingMessageEventProvider: IncomingMessageEventProvider,
  ) {
    // do nothing
    afMessaging.messages.subscribe((message) => {
      appService.logger.debug('🎃 NotificationApi.afMessaging', message);
      this.incomingMessageEventProvider.dispatch(
        new IncomingMessageEvent(new IncomingMessage(message.data)),
      );
    });
  }

  requestPermission(): Promise<string | undefined> {
    return new Promise((resolve, reject) => {
      this._notificationRequestSub = this.afMessaging.requestToken.subscribe({
        next: (token) => (token ? resolve(token) : reject()),
        error: (err) => reject(err),
      });
    });
  }

  destroy() {
    this._notificationRequestSub?.unsubscribe();
  }
}
